module.exports = __webpack_public_path__ + "10_mustache_brown.55fe08e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/10_mustache_brown.png
// module id = jTTj
// module chunks = 0